import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import signupbg from "assets/svg/Inn.svg";

import { useHistory } from "react-router-dom";
import { auth, db } from "./firebase";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        www.jtavn.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    //background: `#161415 url(../assets/img/ftmbg.jpg) no-repeat top center`,
    backgroundImage: `url(${signupbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    //"-webkit-background-size": `cover !important`,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //color: "white",
    height: "fit-content",

    borderRadius: "5px",
    border: "10px solid lightgray",
    padding: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.85)",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  logo: {
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "2rem",
    display: "flex",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const history = useHistory();
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [phonenumber, setPhonenumber] = React.useState("");
  const [role, setRole] = React.useState({
    admin: false,
    manager: false,
    farmer: false,
  });

  const handleChange = (event) => {
    //role({ admin: false, manager: false, farmer: false });
    const newrole = { admin: false, manager: false, farmer: false };
    //console.log("role la: ", newrole);
    setRole({ ...newrole, [event.target.value]: event.target.checked });
  };

  const { admin, manager, farmer } = role;
  const error = [admin, manager, farmer].filter((v) => v).length !== 1;

  const register = (e) => {
    e.preventDefault();
    if (error) {
      alert(" You haven't sellect your role");
      return null
    }
    var hovaten = lastname + " " + firstname;
    console.log("hovaten: ",hovaten);
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        // it successfully created a new user with email and password
        //console.log(auth);
        if (user) {
          
          if (!user.user.displayName) {
            //var hovaten = {lastname} + " " + {firstname};
            auth.currentUser.updateProfile({
              displayName: hovaten,
              photoURL: "",
            })            
          }
          

          console.log("You just create new user:",user);
          /// Create DB userProfile
          // if usertype is admin go admin if manager go manager if farmer go farmer
          // history.push("/admin");
        }
      })
      .then(() => {
        db
        .collection('users')
        .doc(auth.currentUser?.uid)
        .collection('userprofile')
        .doc()
        .set({
          userdisplayname: hovaten,
          useremail: email,
          userrole: role.admin?"admin":role.manager?"manager":"farmer",
          userphonenumber: phonenumber,
          userphoto: auth.currentUser.photoURL,
          usercreationtime: auth.currentUser.metadata.creationTime,
          userlastsignintime: auth.currentUser.metadata.lastSignInTime,
        })
        //history.push("/" + role.admin?"admin":role.manager?"manager":"farmer");
        console.log(" You will go to: ","/" + role.admin?"admin":role.manager?"manager":"farmer");
        switch (role.admin?"admin":role.manager?"manager":"farmer") {
          case 'admin':
            console.log('You will go to admin.');
            history.push("/admin");
            break;
          case 'manager':
            console.log('You will go to manager.');
            history.push("/manager");
            break;
          case 'farmer':
            console.log('You will go to farmer.');
            history.push("/farmer");
            break;
          default:
            console.log("Sorry, you are not going anywhere");
        }
        
      })
      .catch((error) => alert(error.message));
  };

  return (
    <div className={classes.root}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Link href="/home" to="/home" className={classes.logo}>
            FTM
            <i class="fab fa-typo3" />
          </Link>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="fname"
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="lname"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="phonenumber"
                  label="Phone Number"
                  type="number"
                  id="formatted-numberformat-input"
                  
                  value={phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <br></br>
                <FormControl required error={error} component="fieldset">
                  <FormLabel component="legend">
                    Please choose your role in this project
                  </FormLabel>
                  <FormGroup>
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={admin}
                          onChange={handleChange}
                          value="admin"
                          color="primary"
                        />
                      }
                      label="Your role is ADMIN."
                    /> */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={manager}
                          onChange={handleChange}
                          value="manager"
                          color="primary"
                        />
                      }
                      label="Your role is MANAGER."
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={farmer}
                          onChange={handleChange}
                          value="farmer"
                          color="primary"
                        />
                      }
                      label="Your role is FARMER."
                    />
                  </FormGroup>
                  {/* <FormHelperText>
                    {error
                      ? "You can only choose 1 role"
                      : "Yes...It 's correct"}
                  </FormHelperText> */}
                </FormControl>
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={register}
            >
              Sign Up
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Link href="/login" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </form>
          <Box mt={5}>
            <Copyright />
          </Box>
        </div>
      </Container>
    </div>
  );
}
